import {
  Button,
  Grid,
  InputAdornment,
  Typography,
  useTheme,
} from '@mui/material'
import { FieldValues } from 'react-hook-form'
import { FormContainer, TextFieldElement } from 'react-hook-form-mui'

import SearchIcon from '@mui/icons-material/Search'

export interface CustomerSearchProps {
  title?: string
  onSearch: (searchInput?: string | null) => void
}

export function CustomerSearch({ onSearch, title }: CustomerSearchProps) {
  const theme = useTheme()

  const onSubmit = (data: FieldValues) => {
    onSearch(data['searchInput'] || null)
  }
  return (
    <FormContainer onSuccess={(data) => onSubmit(data)}>
      <Grid item pb={1} pl={1}>
        <Typography variant='h4'>{title}</Typography>
      </Grid>
      <TextFieldElement
        name='searchInput'
        placeholder='Leita í töflu'
        sx={{ backgroundColor: theme.palette.background.paper }}
        size='small'
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position='end'>
              <Button type={'submit'} color={'primary'}>
                Leit
              </Button>
            </InputAdornment>
          ),
        }}
      />
    </FormContainer>
  )
}
